import * as React from 'react';
export interface NoPropertyIsAvailablePanelProps { }
export const NoPropertyIsAvailablePanel: React.SFC<NoPropertyIsAvailablePanelProps> = props => {
    return (
        <div className="col-md-9  col-md-push-3">
            No Property is availables with this query. Pleas select another date
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/hotels/NoPropertyIsAvailablePanel.tsx